<template>
  <div id="menu">
    <nav>
      <div>
        <v-app-bar app>
          <v-row align="center">
            <!-- Logo -->
            <v-col cols="3" md="auto" class="custom-logo">
              <router-link :to="'/'">
                <img id="logo-image" :src="require('@/assets/logo-purple.svg')" />
              </router-link>
            </v-col>
            <v-col cols="auto" sm="auto" class="custom-nav-icon text-left" v-if="shouldShowIcon">
              <v-app-bar-nav-icon color="black" @click="drawer = true"> </v-app-bar-nav-icon>
            </v-col>

            <v-spacer></v-spacer>

            <!-- Top Menu Items -->
            <div class="d-flex" v-if="!showSearchInput" v-click-outside="closeOnClickOutside">
              <v-col cols="12" xl="auto" lg="auto" class="custom-column">
                <v-row class="d-flex flex-row justify-start align-center">
                  <!-- Left Items -->
                  <v-col
                    v-for="item in leftItems"
                    :key="item.id"
                    cols="3"
                    md="auto"
                    class="hidden-sm-and-down"
                    :class="isActive(item.text)"
                  >
                    <div>
                      <router-link
                        :to="item.to"
                        v-bind:class="{ 'disabled-link': item.disabled }"
                        v-if="!item.disabled"
                      >
                        <span
                          class="text-medium  hover-effect"
                          @click="handleClick"
                          :style="item.style"
                        >
                          {{ item.text }}
                        </span>
                      </router-link>
                      <span
                        v-if="item.disabled"
                        class="text-medium  hover-effect"
                        :style="item.style"
                      >
                        {{ item.text }}
                      </span>
                    </div>
                  </v-col>
                  <!-- User Management -->
                  <v-col
                    cols="3"
                    md="auto"
                    class="hidden-sm-and-down"
                    v-if="$store.getters.roles === 'super-admin'"
                  >
                    <div>
                      <v-btn
                        class="px-0 no-background-hover"
                        text
                        @click="toggleUserManagementExpand"
                      >
                        <span
                          class="text-medium hover-effect"
                          :style="{
                            fontSize: '12px',
                            color:
                              $route.name === 'PendingRegistration' ||
                              $route.name === 'Users' ||
                              $route.name === 'Subscriptions'
                                ? 'var(--v-primary300-base)'
                                : '',
                            fontWeight:
                              $route.name === 'PendingRegistration' ||
                              $route.name === 'Users' ||
                              $route.name === 'Subscriptions'
                                ? 'bold'
                                : 'normal',
                          }"
                        >
                          User Management
                        </span>
                      </v-btn>
                      <v-icon class="mx-0" right v-if="!isUserManagementOpen">mdi-menu-down</v-icon>
                      <v-icon class="mx-0" right v-if="isUserManagementOpen">mdi-menu-up</v-icon>
                    </div>
                  </v-col>
                  <!-- Resources -->
                  <v-col
                    cols="3"
                    md="auto"
                    class="hidden-sm-and-down"
                    v-if="
                      $store.getters.roles === 'super-admin' || $store.getters.roles === 'provider'
                    "
                  >
                    <div>
                      <v-btn
                        class="px-0 no-background-hover"
                        text
                        @click="handleToggleResourcesExpand"
                        v-if="isAuthorized"
                      >
                        <span
                          class="text-medium hover-effect"
                          :style="{
                            fontSize: '12px',
                            color:
                              $route.name === 'HostingInstitutions' ||
                              $route.name === 'AdminProviders' ||
                              $route.name === 'AdminServices' ||
                              $route.name === 'Services' ||
                              $route.name === 'ServicesAdd' ||
                              $route.name === 'Equipment' ||
                              $route.name === 'EquipmentAdd' ||
                              $route.name === 'AddPatent' ||
                              $route.name === 'Patents'
                                ? 'var(--v-primary300-base)'
                                : '',
                            fontWeight:
                              $route.name === 'HostingInstitutions' ||
                              $route.name === 'AdminProviders' ||
                              $route.name === 'AdminServices' ||
                              $route.name === 'Services' ||
                              $route.name === 'ServicesAdd' ||
                              $route.name === 'Equipment' ||
                              $route.name === 'EquipmentAdd' ||
                              $route.name === 'AddPatent' ||
                              $route.name === 'Patents'
                                ? 'bold'
                                : 'normal',
                          }"
                        >
                          Resources
                        </span>
                      </v-btn>
                      <v-icon class="mx-0" right v-if="!isResourcesOpen">mdi-menu-down</v-icon>
                      <v-icon class="mx-0" right v-if="isResourcesOpen">mdi-menu-up</v-icon>
                    </div>
                  </v-col>
                  <!-- Right Items -->
                  <v-col
                    v-for="item in rightItems"
                    :key="item.id"
                    cols="3"
                    md="auto"
                    class="hidden-sm-and-down"
                    :class="isActive(item.text)"
                  >
                    <div>
                      <router-link
                        :to="item.to"
                        v-bind:class="{ 'disabled-link': item.disabled }"
                        v-if="!item.disabled"
                      >
                        <span
                          class="text-medium  hover-effect"
                          @click="handleClick"
                          :style="item.style"
                        >
                          {{ item.text }}
                        </span>
                      </router-link>
                      <span
                        v-if="item.disabled"
                        class="text-medium  hover-effect"
                        :style="item.style"
                      >
                        {{ item.text }}
                      </span>
                    </div>
                  </v-col>
                  <!-- Campaign & News -->
                  <v-col
                    cols="3"
                    md="auto"
                    class="hidden-sm-and-down"
                    v-if="$store.getters.roles === 'super-admin'"
                  >
                    <div>
                      <v-btn
                        class="px-0 no-background-hover"
                        text
                        @click="toggleCampaignAndNewsExpand"
                      >
                        <span
                          class="text-medium hover-effect"
                          :style="{
                            fontSize: '12px',
                            color:
                              $route.name === 'Campaign' || $route.name === 'NewsAndEvents'
                                ? 'var(--v-primary300-base)'
                                : '',
                            fontWeight:
                              $route.name === 'Campaign' || $route.name === 'NewsAndEvents'
                                ? 'bold'
                                : 'normal',
                          }"
                        >
                          Campaign & News
                        </span>
                      </v-btn>
                      <v-icon class="mx-0" right v-if="!isCampaignAndNewsOpen"
                        >mdi-menu-down</v-icon
                      >
                      <v-icon class="mx-0" right v-if="isCampaignAndNewsOpen">mdi-menu-up</v-icon>
                    </div>
                  </v-col>
                </v-row>
              </v-col>
            </div>

            <v-spacer></v-spacer>

            <!-- Search, Notification & Profile Image -->
            <v-col cols="auto" md="auto" xs="auto" class="text-right">
              <v-row class="custom-row">
                <v-btn
                  class="custom-search-bar-button"
                  v-if="!showSearchInput"
                  @click="openSearchBar"
                  small
                  plain
                >
                  <v-icon>mdi-magnify </v-icon>
                </v-btn>
                <div v-if="showSearchInput" class="search-bar-container">
                  <input-autocomplete-search
                    v-model="search"
                    placeholder="What are you looking for?"
                    label=""
                    :is-combobox="true"
                    prepend-inner-icon="mdi-magnify"
                    outlined
                    rounded
                    clearable
                    :hide-details="true"
                    data-cy="search-generic"
                    :item-value="'id'"
                    :item-text="'name'"
                    :url="'/api/v1/resources/by-name?name='"
                    @click:prepend-inner="triggerSearch"
                    @keyup.native.enter="triggerSearch"
                    @update:search-input="searchChange"
                    @change="triggerSearch"
                  >
                  </input-autocomplete-search>
                  <div class="ml-2">
                    <v-btn
                      small
                      color="neutral700"
                      style="height: 100%; border: 1px solid #C3C2C7; border-radius: 8px;"
                      outlined
                      @click="openFilterDrawer"
                    >
                      <v-icon color="primary200">$vuetify.icons.filter</v-icon>
                    </v-btn>
                  </div>
                  <v-icon @click="closeSearch" class="ml-1">mdi-close </v-icon>
                </div>

                <v-col md="auto" sm="auto" v-if="!showSearchInput">
                  <v-btn
                    class="custom-fitler-drawer-button"
                    small
                    color="neutral700"
                    plain
                    style="height: 100%; border-radius: 8px;"
                    @click="openFilterDrawer"
                  >
                    <v-icon>$vuetify.icons.filter</v-icon>
                  </v-btn>
                  <v-menu
                    offset-y
                    transition="scale-transition"
                    max-width="600px"
                    style="width: auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn icon large v-bind="attrs" v-on="on" class="mr-2">
                        <v-badge
                          :value="notificationsTotalLength"
                          overlap
                          color="pink"
                          :content="notificationsTotalLength"
                        >
                          <v-icon color="primary">$vuetify.icon.bell</v-icon>
                        </v-badge>
                      </v-btn>
                    </template>
                    <v-list v-if="notificationsTotalLength" dense>
                      <div class="d-flex flex-row pl-6 pr-8 my-4">
                        <v-subheader class="mr-auto">Notifications</v-subheader>
                        <div class="align-self-center">
                          <router-link :to="{ name: 'Notifications' }" class="on-hover-underline"
                            >View All
                          </router-link>
                        </div>
                      </div>
                      <v-list-item
                        v-for="notification in notifications"
                        :key="'not_' + notification.id"
                      >
                        <notification-item
                          :notification="notification"
                          :show-buttons="false"
                        ></notification-item>
                      </v-list-item>
                    </v-list>
                    <v-list v-else>
                      <div class="d-flex flex-column pl-6 pr-8 my-4">
                        <v-subheader class="mr-auto">No notifications</v-subheader>
                        <div class="align-self-center">
                          <router-link :to="{ name: 'Notifications' }" class="on-hover-underline"
                            >View All
                          </router-link>
                        </div>
                      </div>
                    </v-list>
                  </v-menu>
                  <v-menu offset-y :close-on-content-click="true" rounded="xl">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        icon
                        v-bind="attrs"
                        v-on="on"
                        data-cy="userMenu"
                        id="avatar"
                        class="no-background-hover mr-md-8 mr-2"
                      >
                        <profile-image></profile-image>
                      </v-btn>
                    </template>
                    <v-list class="pt-10 text-center" id="dropdown-list">
                      <profile-image
                        :size="'80px'"
                        :upload="true"
                        :position="'dropdown-image'"
                        :text-size="'text-sm-h4'"
                      ></profile-image>
                      <h4 class="pt-2">{{ $store.getters.fullName }}</h4>
                      <h6>{{ $store.getters.email }}</h6>
                      <h6 class="pt-2 mb-4 secondary400--text" style="font-size: 13px">
                        {{ setRole() }}
                      </h6>
                      <v-btn
                        v-if="$store.getters.roles != 'provider'"
                        id="account-settings"
                        depressed
                        outlined
                        rounded
                        class="font-weight-bold text-capitalize"
                        color="primary200"
                        link
                        :to="{ name: 'Profile' }"
                        >{{ $t('account-settings') }}
                      </v-btn>
                      <div v-else>
                        <v-btn
                          depressed
                          rounded
                          class="font-weight-bold white--text mb-2"
                          color="primary200"
                          link
                          :to="{ name: 'Profile' }"
                          >{{ $t('account-settings') }}
                        </v-btn>
                        <v-btn
                          :disabled="isFirstTime()"
                          id="account-settings"
                          depressed
                          outlined
                          rounded
                          class="font-weight-bold"
                          color="primary200"
                          link
                          :to="{
                            name: 'EditProvider',
                            params: {
                              id: selectedProviderId,
                            },
                          }"
                          >{{ $t('provider-settings') }}
                        </v-btn>
                      </div>
                      <div
                        v-if="
                          $store.getters.roles === 'institution-representative' &&
                            selectedRepresentativeId
                        "
                      >
                        <v-btn
                          :to="{
                            name: 'EditHostingInstitution',
                            params: {
                              id: selectedRepresentativeId,
                            },
                          }"
                          id="account-settings"
                          depressed
                          outlined
                          rounded
                          class="font-weight-bold mt-4"
                          color="primary200"
                          link
                          >{{ $t('hosting-institution-settings') }}
                        </v-btn>
                      </div>
                      <v-divider
                        class="mt-4 mx-6"
                        v-if="
                          $store.getters.roles === 'provider' ||
                            $store.getters.roles === 'institution-representative'
                        "
                      ></v-divider>
                      <div
                        v-if="$store.getters.roles === 'institution-representative'"
                        style="max-height: 300px; overflow-y: auto; "
                        class="mt-2"
                      >
                        <v-chip
                          v-if="selectedRepresentativeId != null"
                          flat
                          label
                          medium
                          color="primary200"
                          class="white--text font-weight-bold"
                        >
                          {{ hostingRepresentative.name }}
                        </v-chip>

                        <v-chip v-else>
                          No Representatives yet
                        </v-chip>
                      </div>
                      <div style="max-height: 300px; overflow-y: auto;">
                        <v-list class="mb-0" dense v-if="$store.getters.roles == 'provider'">
                          <v-list-item-group mandatory v-model="selectedProviderId" color="primary">
                            <v-list-item v-for="(item, i) in providers" :key="i" :value="item.id">
                              <v-list-item-content>
                                <v-list-item-title v-text="item.name"></v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>
                          </v-list-item-group>
                        </v-list>
                      </div>
                      <div
                        v-if="$store.getters.roles == 'provider' && providers.length == 0"
                        class="mb-4"
                      >
                        No providers yet
                      </div>
                      <v-divider
                        class="mt-1 mb-1 mx-6"
                        v-if="$store.getters.roles == 'provider'"
                      ></v-divider>
                      <div v-if="$store.getters.roles == 'provider'" class="mb-2 font-weight-bold">
                        <v-btn
                          :disabled="isFirstTime()"
                          color="neutral700"
                          class="font-family-medium"
                          text
                          :to="{ name: 'AddProvider' }"
                        >
                          <v-icon class="mr-1">$vuetify.icons.addProvider</v-icon>
                          Add new provider
                        </v-btn>
                      </div>
                      <v-divider class="mb-2 mx-6 mt-2"></v-divider>
                      <v-btn
                        color="neutral700"
                        class="mb-2 font-family-medium"
                        text
                        @click="logout"
                      >
                        <v-icon class="mr-1">$vuetify.icons.signOut</v-icon>
                        {{ $t('logout') }}
                      </v-btn>
                    </v-list>
                  </v-menu>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-app-bar>
      </div>

      <v-system-bar window color="white" v-if="breadcrumbPath.length > 0">
        <v-row>
          <v-col
            cols="2"
            sm="1"
            lg="2"
            md="2"
            xl="2"
            class="hidden-xs-only mr-lg-5 mr-sm-4"
          ></v-col>
          <v-breadcrumbs
            style="z-index: 1 !important;"
            :items="breadcrumbPath"
            divider=">"
          ></v-breadcrumbs>
        </v-row>
      </v-system-bar>

      <v-expand-transition>
        <div class="overlay-content">
          <!-- User Management -->
          <div v-if="isUserManagementOpen" class="expandable-content">
            <v-container>
              <v-row class="mb-16 justify-center">
                <v-col md="auto">
                  <v-list nav class="custom-list">
                    <v-list-item
                      v-for="item in userManagementItems"
                      :key="item.id"
                      link
                      :to="item.to"
                      @click="handleClick"
                    >
                      <v-list-item-title>
                        <span class="text-medium neutral--text" :style="item.style">
                          {{ item.text }}
                        </span>
                      </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-col>
              </v-row>
            </v-container>
          </div>
          <!-- Resources -->
          <div v-if="isResourcesOpen" class="expandable-content" ref="resourcesMenu">
            <v-container>
              <v-row class="mb-16 justify-center">
                <v-col md="auto">
                  <v-list nav class="custom-list">
                    <v-list-item
                      v-for="item in resourcesItems"
                      :key="item.id"
                      link
                      :to="item.to"
                      @click="handleClick(item)"
                    >
                      <v-list-item-title>
                        <span class="text-medium neutral--text" :style="item.style">
                          {{ item.text }}
                        </span>
                      </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-col>
                <v-col v-if="adminResourcesIntellectualPropertiesOpen" cols="auto">
                  <v-list nav class="custom-list">
                    <v-list-item
                      v-for="item in adminResourcesIntellectualProperties"
                      :key="item.id"
                      :to="item.to"
                      link
                      @click="handleClick"
                    >
                      <v-list-item-title>
                        <span class="text-medium neutral--text" :style="item.style">
                          {{ item.text }}
                        </span>
                      </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-col>
              </v-row>
            </v-container>
          </div>
          <!-- Provider Resources -->
          <div v-if="isResourcesProviderOpen" class="expandable-content" ref="resourcesMenu">
            <v-container>
              <v-row class="mb-16 justify-center">
                <v-col cols="auto">
                  <v-list nav class="custom-list">
                    <v-subheader style="font-size: 20px;">
                      Your Resources
                    </v-subheader>
                    <v-list-item
                      v-for="item in yourResourcesItems"
                      :key="item.id"
                      link
                      :to="item.to"
                      @click="handleClick(item)"
                    >
                      <v-list-item-title>
                        <span class="text-medium neutral--text" :style="item.style">
                          {{ item.text }}
                        </span>
                      </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-col>
                <v-col v-if="resourcesIntellectualPropertiesOpen" cols="auto">
                  <v-list nav class="custom-list">
                    <v-subheader style="font-size: 20px;">
                      Your Intellectual Properties
                    </v-subheader>
                    <v-list-item
                      v-for="item in resourcesIntellectualProperties"
                      :key="item.id"
                      :to="item.to"
                      link
                      @click="handleClick"
                    >
                      <v-list-item-title>
                        <span class="text-medium neutral--text" :style="item.style">
                          {{ item.text }}
                        </span>
                      </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-col>
                <v-col cols="auto">
                  <v-list nav class="custom-list">
                    <v-subheader style="font-size: 20px;">
                      Add Resources
                    </v-subheader>
                    <v-list-item
                      v-for="item in addResourcesItems"
                      :key="item.id"
                      link
                      :to="item.to"
                      @click="handleClick(item)"
                    >
                      <v-list-item-title>
                        <span class="text-medium neutral--text" :style="item.style">
                          {{ item.text }}
                        </span>
                      </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-col>
                <v-col v-if="addIntellectualPropertiesOpen" cols="auto">
                  <v-list nav class="custom-list">
                    <v-subheader style="font-size: 20px;">
                      Add Intellectual Properties
                    </v-subheader>
                    <v-list-item
                      v-for="item in addIntellectualProperties"
                      :key="item.id"
                      :to="item.to"
                      link
                      @click="handleClick"
                    >
                      <v-list-item-title>
                        <span class="text-medium neutral--text" :style="item.style">
                          {{ item.text }}
                        </span>
                      </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-col>
              </v-row>
            </v-container>
          </div>
          <!-- Campaign & News -->
          <div v-if="isCampaignAndNewsOpen" class="expandable-content">
            <v-container>
              <v-row class="mb-16 justify-end">
                <v-spacer></v-spacer>
                <v-col xl="7" md="9" class="d-flex justify-end">
                  <v-list nav class="custom-list">
                    <v-list-item
                      v-for="item in campaignAndNewsItems"
                      :key="item.id"
                      link
                      :to="item.to"
                      @click="handleClick"
                    >
                      <v-list-item-title>
                        <span class="text-medium neutral--text" :style="item.style">
                          {{ item.text }}
                        </span>
                      </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-col>
                <v-spacer></v-spacer>
              </v-row>
            </v-container>
          </div>
        </div>
      </v-expand-transition>

      <v-navigation-drawer
        v-model="drawer"
        absolute
        temporary
        width="auto"
        style="position: fixed; top: 0; bottom: 0;"
      >
        <!-- Logo -->
        <v-list-item class="mt-4 mb-12">
          <v-list-item-content id="logo">
            <v-list-item-title class="d-flex align-center justify-start">
              <div class="d-inline">
                <router-link :to="{ name: 'LandingPage' }"
                  ><img style="max-width: 184px" src="@/assets/logo-purple.svg"
                /></router-link>
              </div>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list>
          <!-- Left Items -->
          <v-list-item v-for="item in leftItems" :key="item.id" :to="item.to">
            <v-list-item-action>
              <v-icon color="black">$vuetify.icons.{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <span class="text-medium neutral--text">
                {{ item.text }}
              </span>
            </v-list-item-content>
          </v-list-item>
          <!-- User Management -->
          <v-list-group v-if="$store.getters.roles === 'super-admin'">
            <template v-slot:activator>
              <v-icon color="black ml-0 pl-0">$vuetify.icons.userManagement</v-icon>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>
                    <span class="text-medium neutral--text">User Management</span>
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
            <v-list nav class="deep-purple accent-1">
              <v-list-item v-for="item in userManagementItems" :key="item.id" :to="item.to">
                <v-list-item-action>
                  <v-icon color="black">$vuetify.icons.{{ item.icon }}</v-icon>
                </v-list-item-action>
                <v-list-item-title>
                  <span class="text-medium neutral--text text-subtitle-2">
                    {{ item.text }}
                  </span>
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-list-group>
          <!-- Resources -->
          <v-list-group v-if="isAuthorized">
            <template v-slot:activator>
              <v-icon color="black ml-0 pl-0">$vuetify.icons.resources</v-icon>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>
                    <span class="text-medium neutral--text">Resources</span>
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
            <v-list nav class="deep-purple accent-1" v-if="$store.getters.roles === 'super-admin'">
              <v-list-item
                v-for="item in resourcesItems"
                :key="item.id"
                :to="item.to"
                @click="handleDrawerClick(item)"
              >
                <v-list-item-action>
                  <v-icon color="black">$vuetify.icons.{{ item.icon }}</v-icon>
                </v-list-item-action>
                <v-list-item-title>
                  <span class="text-medium neutral--text text-subtitle-2">
                    {{ item.text }}
                  </span>
                </v-list-item-title>
              </v-list-item>
            </v-list>
            <v-list
              nav
              class="deep-purple accent-1"
              v-if="
                $store.getters.roles === 'super-admin' && adminResourcesIntellectualPropertiesOpen
              "
            >
              <v-subheader style="font-size: 18px;">
                Intellectual Properties
              </v-subheader>
              <v-list-item
                v-for="item in adminResourcesIntellectualProperties"
                :key="item.id"
                :to="item.to"
              >
                <v-list-item-action>
                  <v-icon color="black">$vuetify.icons.{{ item.icon }}</v-icon>
                </v-list-item-action>
                <v-list-item-title>
                  <span class="text-medium neutral--text text-subtitle-2">
                    {{ item.text }}
                  </span>
                </v-list-item-title>
              </v-list-item>
            </v-list>
            <v-list nav class="deep-purple accent-1" v-if="$store.getters.roles === 'provider'">
              <v-subheader style="font-size: 18px;">
                Your Resources
              </v-subheader>
              <v-list-item
                v-for="item in yourResourcesItems"
                :key="item.id"
                :to="item.to"
                @click="handleDrawerClick(item)"
              >
                <v-list-item-action>
                  <v-icon color="black">$vuetify.icons.{{ item.icon }}</v-icon>
                </v-list-item-action>
                <v-list-item-title>
                  <span class="text-medium neutral--text text-subtitle-2">
                    {{ item.text }}
                  </span>
                </v-list-item-title>
              </v-list-item>
            </v-list>
            <v-list
              nav
              class="deep-purple accent-1"
              v-if="$store.getters.roles === 'provider' && resourcesIntellectualPropertiesOpen"
            >
              <v-subheader style="font-size: 18px;">
                Your Intellectual Properties
              </v-subheader>
              <v-list-item
                v-for="item in resourcesIntellectualProperties"
                :key="item.id"
                :to="item.to"
              >
                <v-list-item-action>
                  <v-icon color="black">$vuetify.icons.{{ item.icon }}</v-icon>
                </v-list-item-action>
                <v-list-item-title>
                  <span class="text-medium neutral--text text-subtitle-2">
                    {{ item.text }}
                  </span>
                </v-list-item-title>
              </v-list-item>
            </v-list>
            <v-list nav class="deep-purple accent-1" v-if="$store.getters.roles === 'provider'">
              <v-subheader style="font-size: 18px;">
                Add Resources
              </v-subheader>
              <v-list-item
                v-for="item in addResourcesItems"
                :key="item.id"
                :to="item.to"
                @click="handleDrawerClick(item)"
              >
                <v-list-item-action>
                  <v-icon color="black">$vuetify.icons.{{ item.icon }}</v-icon>
                </v-list-item-action>
                <v-list-item-title>
                  <span class="text-medium neutral--text text-subtitle-2">
                    {{ item.text }}
                  </span>
                </v-list-item-title>
              </v-list-item>
            </v-list>
            <v-list
              nav
              class="deep-purple accent-1"
              v-if="$store.getters.roles === 'provider' && addIntellectualPropertiesOpen"
            >
              <v-subheader style="font-size: 18px;">
                Add Intellectual Properties
              </v-subheader>
              <v-list-item v-for="item in addIntellectualProperties" :key="item.id" :to="item.to">
                <v-list-item-action>
                  <v-icon color="black">$vuetify.icons.{{ item.icon }}</v-icon>
                </v-list-item-action>
                <v-list-item-title>
                  <span class="text-medium neutral--text text-subtitle-2">
                    {{ item.text }}
                  </span>
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-list-group>
          <!-- Right Items -->
          <v-list-item v-for="item in rightItems" :key="item.id" :to="item.to">
            <v-list-item-action>
              <v-icon color="black">$vuetify.icons.{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <span class="text-medium neutral--text">
                {{ item.text }}
              </span>
            </v-list-item-content>
          </v-list-item>
          <!-- Campaign & News -->
          <v-list-group v-if="$store.getters.roles === 'super-admin'">
            <template v-slot:activator>
              <v-icon color="black ml-0 pl-0">$vuetify.icons.news</v-icon>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>
                    <span class="text-medium neutral--text">Campaign & News</span>
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
            <v-list nav class="deep-purple accent-1">
              <v-list-item v-for="item in campaignAndNewsItems" :key="item.id" :to="item.to">
                <v-list-item-action>
                  <v-icon color="black">$vuetify.icons.{{ item.icon }}</v-icon>
                </v-list-item-action>
                <v-list-item-title>
                  <span class="text-medium neutral--text text-subtitle-2">
                    {{ item.text }}
                  </span>
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-list-group>
        </v-list>
      </v-navigation-drawer>
    </nav>
  </div>
</template>

<script>
import util from '@/mixins/util.js';
import ProfileImage from '@/components/shared/profile/ProfileImage';
import EventBus from '@/helpers/event-bus';
import InputAutocompleteSearch from '@/components/shared/inputs/InputAutocompleteSearch';
import NotificationItem from '@/components/notifications/NotificationItem';

export default {
  name: 'TopMenu',
  mixins: [util],
  components: { InputAutocompleteSearch, ProfileImage, NotificationItem },
  props: {
    providerId: {
      type: [Number],
      default: null,
    },
    representativeId: {
      type: [Number],
      default: null,
    },
    hostingRepresentative: Object,
    providers: Array,
  },
  data() {
    return {
      notifications: 0,
      notificationsTotalLength: 0,
      search: null,
      menuFilter: false,
      breadcrumbPath: [],
      selectedProviderId: null,
      selectedRepresentativeId: null,
      showSearchInput: false,
      isUserManagementOpen: false,
      isResourcesOpen: false,
      isResourcesProviderOpen: false,
      drawer: false,
      isCampaignAndNewsOpen: false,
      addIntellectualPropertiesOpen: false,
      resourcesIntellectualPropertiesOpen: false,
      adminResourcesIntellectualPropertiesOpen: false,
    };
  },
  created() {
    this.loadNotifications();
    setInterval(() => {
      this.loadNotifications();
    }, 5000);
    this.updateBreadcrumb();
    if (this.providerId != null) {
      this.selectedProviderId = this.providers.find(x => x.id == this.providerId).id;
    }
    if (this.representativeId != null) {
      this.selectedRepresentativeId = this.hostingRepresentative.id;
    }
    console.log(this.$vuetify.breakpoint.name);
  },
  methods: {
    closeOnClickOutside(event) {
      const resourcesMenu = this.$refs.resourcesMenu;

      const isOutsideResourcesMenu = resourcesMenu && !resourcesMenu.contains(event.target);

      if (isOutsideResourcesMenu) {
        this.isResourcesOpen = false;
        this.isResourcesProviderOpen = false;
      }

      this.isUserManagementOpen = false;

      this.isCampaignAndNewsOpen = false;
    },
    setRole() {
      if (this.$store.getters.roles.indexOf('researcher') >= 0) {
        return 'User';
      }
      return this.$store.getters.roles.charAt(0).toUpperCase() + this.$store.getters.roles.slice(1);
    },
    loadNotifications() {
      this.axios.get('/api/v1/notifications?read=false&size=5').then(res => {
        this.notifications = res.data.content;
        this.notificationsTotalLength = res.data.total;
      });
    },
    updateBreadcrumb() {
      if (
        this.$router.currentRoute.meta.breadcrumbPath &&
        this.$router.currentRoute.meta.breadcrumbPath.length > 0
      ) {
        this.breadcrumbPath = this.$router.currentRoute.meta.breadcrumbPath;
      } else {
        this.breadcrumbPath = [];
      }
    },
    openFilterDrawer() {
      EventBus.$emit('filtering', true);
    },
    openSearchBar() {
      this.showSearchInput = !this.showSearchInput;
      this.isUserManagementOpen = false;
      this.isResourcesOpen = false;
      this.isResourcesProviderOpen = false;
      this.isCampaignAndNewsOpen = false;
      this.addIntellectualPropertiesOpen = false;
      this.resourcesIntellectualPropertiesOpen = false;
      this.adminResourcesIntellectualPropertiesOpen = false;
    },
    closeSearch() {
      this.showSearchInput = false;
      this.search = '';
    },
    triggerSearch(value) {
      if (value != null) {
        console.log('Trigger generic search');

        let searchText = this.search?.name || this.search;
        searchText = searchText.replace(/\s+$/, '');

        this.$router.push({
          name: 'SearchMarketplace',
          query: { text: searchText },
        });
      }
    },
    searchChange(value) {
      this.search = value;
    },
    toggleUserManagementExpand() {
      this.isUserManagementOpen = !this.isUserManagementOpen;
      this.isResourcesOpen = false;
      this.showSearchInput = false;
      this.isCampaignAndNewsOpen = false;
    },
    toggleResourcesExpand() {
      this.isResourcesOpen = !this.isResourcesOpen;
      this.isUserManagementOpen = false;
      this.showSearchInput = false;
      this.isCampaignAndNewsOpen = false;
    },
    toggleCampaignAndNewsExpand() {
      this.isCampaignAndNewsOpen = !this.isCampaignAndNewsOpen;
      this.isUserManagementOpen = false;
      this.showSearchInput = false;
      this.isResourcesOpen = false;
    },
    toggleResourcesProviderExpand() {
      this.isResourcesProviderOpen = !this.isResourcesProviderOpen;
      this.showSearchInput = false;
    },
    isActive(itemText) {
      return (
        this.leftItems.some(item => item.text === itemText) ||
        this.rightItems.some(item => item.text === itemText)
      );
    },
    handleClick(item) {
      this.isResourcesOpen = false;
      this.isUserManagementOpen = false;
      this.showSearchInput = false;
      this.isResourcesProviderOpen = false;
      this.isCampaignAndNewsOpen = false;

      if (item.value === 'addResourcesIntellectualProperties') {
        this.isResourcesProviderOpen = true;
        this.addIntellectualPropertiesOpen = !this.addIntellectualPropertiesOpen;
      }

      if (item.value === 'resourcesIntellectualProperties') {
        this.isResourcesProviderOpen = true;
        this.resourcesIntellectualPropertiesOpen = !this.resourcesIntellectualPropertiesOpen;
      }

      if (item.value === 'adminResourcesIntellectualProperties') {
        this.isResourcesOpen = true;
        this.adminResourcesIntellectualPropertiesOpen = !this
          .adminResourcesIntellectualPropertiesOpen;
      }
    },
    handleDrawerClick(item) {
      if (item.value === 'addResourcesIntellectualProperties') {
        this.addIntellectualPropertiesOpen = !this.addIntellectualPropertiesOpen;
      }

      if (item.value === 'resourcesIntellectualProperties') {
        this.resourcesIntellectualPropertiesOpen = !this.resourcesIntellectualPropertiesOpen;
      }

      if (item.value === 'adminResourcesIntellectualProperties') {
        this.adminResourcesIntellectualPropertiesOpen = !this
          .adminResourcesIntellectualPropertiesOpen;
      }
    },
    handleToggleResourcesExpand() {
      const role = this.$store.getters.roles;
      if (role === 'super-admin') {
        this.toggleResourcesExpand();
      } else if (role === 'provider') {
        this.toggleResourcesProviderExpand();
      }
    },
  },
  computed: {
    shouldShowIcon() {
      return !(this.showSearchInput && this.$vuetify.breakpoint.width <= 500);
    },
    userManagementItems() {
      if (this.$store.getters.roles === 'super-admin') {
        return [
          {
            id: 0,
            icon: 'pendingRegistration',
            text: 'Pending Registration',
            to: {
              name: 'PendingRegistration',
            },
            style: { fontSize: '12px' },
          },
          {
            icon: 'users',
            text: 'Users',
            to: {
              name: 'Users',
            },
            style: { fontSize: '12px' },
          },
          {
            icon: 'email',
            text: 'Subscriptions',
            to: {
              name: 'Subscriptions',
            },
            style: { fontSize: '12px' },
          },
        ];
      } else {
        return [];
      }
    },
    resourcesItems() {
      if (this.$store.getters.roles === 'super-admin') {
        return [
          {
            icon: 'institution',
            text: 'Hosting Institutions',
            to: {
              name: 'HostingInstitutions',
            },
            style: { fontSize: '12px' },
          },
          {
            icon: 'providers',
            text: 'Providers',
            to: {
              name: 'AdminProviders',
            },
            style: { fontSize: '12px' },
          },
          {
            icon: 'yourResources',
            text: 'Services',
            to: {
              name: 'AdminServices',
            },
            style: { fontSize: '12px' },
          },
          {
            icon: 'equipment',
            text: 'Equipment',
            to: {
              name: 'Equipment',
            },
            style: { fontSize: '12px' },
          },
          {
            icon: 'intellectualProperty',
            text: 'Intellectual Properties',
            value: 'adminResourcesIntellectualProperties',
            style: { fontSize: '12px' },
          },
        ];
      } else {
        return [];
      }
    },
    yourResourcesItems() {
      if (this.$store.getters.roles === 'provider' && !this.isFirstTime()) {
        return [
          {
            icon: 'equipment',
            text: 'Equipment',
            to: {
              name: 'Equipment',
            },
            style: { fontSize: '12px' },
          },
          {
            icon: 'yourResources',
            text: 'Services',
            to: {
              name: 'Services',
            },
            style: { fontSize: '12px' },
          },
          {
            icon: 'intellectualProperty',
            text: 'Intellectual Properties',
            value: 'resourcesIntellectualProperties',
            style: { fontSize: '12px' },
          },
          {
            icon: 'institution',
            text: 'Hosting Institutions',
            to: {
              name: 'HostingInstitutions',
            },
            style: { fontSize: '12px' },
          },
        ];
      } else {
        return [];
      }
    },
    addIntellectualProperties() {
      if (this.$store.getters.roles === 'provider') {
        return [
          {
            icon: 'patent',
            text: 'Patents',
            to: {
              name: 'AddPatent',
            },
            style: { fontSize: '12px' },
          },
        ];
      } else {
        return [];
      }
    },
    adminResourcesIntellectualProperties() {
      if (this.$store.getters.roles === 'super-admin') {
        return [
          {
            icon: 'patent',
            text: 'Patents',
            to: {
              name: 'Patents',
            },
            style: { fontSize: '12px' },
          },
        ];
      } else {
        return [];
      }
    },
    resourcesIntellectualProperties() {
      if (this.$store.getters.roles === 'provider') {
        return [
          {
            icon: 'patent',
            text: 'Patents',
            to: {
              name: 'Patents',
            },
            style: { fontSize: '12px' },
          },
        ];
      } else {
        return [];
      }
    },
    addResourcesItems() {
      if (this.$store.getters.roles === 'provider' && !this.isFirstTime()) {
        return [
          {
            icon: 'equipment',
            text: 'Equipment',
            to: {
              name: 'EquipmentAdd',
            },
            style: { fontSize: '12px' },
          },
          {
            icon: 'addResources',
            text: 'Services',
            to: {
              name: 'ServicesAdd',
            },
            style: { fontSize: '12px' },
          },
          {
            icon: 'intellectualProperty',
            text: 'Intellectual Properties',
            value: 'addResourcesIntellectualProperties',
            style: { fontSize: '12px' },
          },
        ];
      } else {
        return [];
      }
    },
    leftItems() {
      if (this.$store.getters.roles === 'super-admin') {
        return [
          {
            icon: 'dashboard',
            text: 'Dashboard',
            to: { name: 'Dashboard' },
            style: {
              fontSize: '12px',
              color: this.$route.name === 'Dashboard' ? 'var(--v-primary300-base)' : '',
              fontWeight: this.$route.name === 'Dashboard' ? 'bold' : 'normal',
            },
          },
          {
            icon: 'controlValues',
            text: 'Control Values',
            to: {
              name: 'ControlValues',
            },
            style: {
              fontSize: '12px',
              color: this.$route.name === 'ControlValues' ? 'var(--v-primary300-base)' : '',
              fontWeight: this.$route.name === 'ControlValues' ? 'bold' : 'normal',
            },
          },
          {
            icon: 'statistics',
            text: 'Statistics',
            to: {
              name: 'Statistics',
            },
            style: {
              fontSize: '12px',
              color: this.$route.name === 'Statistics' ? 'var(--v-primary300-base)' : '',
              fontWeight: this.$route.name === 'Statistics' ? 'bold' : 'normal',
            },
          },
          {
            icon: 'favorite',
            text: 'Favorites',
            to: {
              name: 'MyFavorites',
            },
            style: {
              fontSize: '12px',
              color: this.$route.name === 'MyFavorites' ? 'var(--v-primary300-base)' : '',
              fontWeight: this.$route.name === 'MyFavorites' ? 'bold' : 'normal',
            },
          },
        ];
      } else if (this.$store.getters.roles === 'provider') {
        const activeMarketplace =
          this.$route.path.includes('/marketplace/services') ||
          this.$route.path.includes('/marketplace/equipment') ||
          this.$route.path.includes('/marketplace/providers') ||
          this.$route.path.includes('/marketplace/patents') ||
          this.$route.path.includes('/marketplace/hosting-institutions');
        return [
          {
            icon: 'dashboard',
            text: 'Dashboard',
            to: {
              name: 'Dashboard',
            },
            style: {
              fontSize: '12px',
              color: this.$route.name === 'Dashboard' ? 'var(--v-primary300-base)' : '',
              fontWeight: this.$route.name === 'Dashboard' ? 'bold' : 'normal',
            },
            disabled: this.isFirstTime(),
          },
          {
            icon: 'marketplace',
            text: 'Catalogue',
            to: {
              path: '/marketplace/services',
              query: {
                selectedCatalogue: 'Browse the Catalogue of Services',
              },
            },
            style: {
              fontSize: '12px',
              color: activeMarketplace ? 'var(--v-primary300-base)' : '',
              fontWeight: activeMarketplace ? 'bold' : 'normal',
            },
          },
          {
            icon: 'favorite',
            text: 'Favorites',
            to: {
              name: 'MyFavorites',
            },
            style: {
              fontSize: '12px',
              color: this.$route.name === 'MyFavorites' ? 'var(--v-primary300-base)' : '',
              fontWeight: this.$route.name === 'MyFavorites' ? 'bold' : 'normal',
            },
            disabled: this.isFirstTime(),
          },
          {
            icon: 'suggested',
            text: 'Suggested',
            to: {
              name: 'Suggested',
            },
            style: {
              fontSize: '12px',
              color: this.$route.name === 'Suggested' ? 'var(--v-primary300-base)' : '',
              fontWeight: this.$route.name === 'Suggested' ? 'bold' : 'normal',
            },
            disabled: this.isFirstTime(),
          },
        ];
      } else if (this.$store.getters.roles === 'researcher') {
        const activeMarketplace =
          this.$route.path.includes('/marketplace/services') ||
          this.$route.path.includes('/marketplace/equipment') ||
          this.$route.path.includes('/marketplace/providers') ||
          this.$route.path.includes('/marketplace/patents') ||
          this.$route.path.includes('/marketplace/hosting-institutions');
        return [
          {
            icon: 'marketplace',
            text: 'Catalogue',
            to: {
              path: '/marketplace/services',
              query: {
                selectedCatalogue: 'Browse the Catalogue of Services',
              },
            },
            style: {
              fontSize: '12px',
              color: activeMarketplace ? 'var(--v-primary300-base)' : '',
              fontWeight: activeMarketplace ? 'bold' : 'normal',
            },
          },
          {
            icon: 'favorite',
            text: 'Favorites',
            to: {
              name: 'MyFavorites',
            },
            style: {
              fontSize: '12px',
              color: this.$route.name === 'MyFavorites' ? 'var(--v-primary300-base)' : '',
              fontWeight: this.$route.name === 'MyFavorites' ? 'bold' : 'normal',
            },
          },
          {
            icon: 'suggested',
            text: 'Suggested',
            to: {
              name: 'Suggested',
            },
            style: {
              fontSize: '12px',
              color: this.$route.name === 'Suggested' ? 'var(--v-primary300-base)' : '',
              fontWeight: this.$route.name === 'Suggested' ? 'bold' : 'normal',
            },
          },
          {
            icon: 'myCollection',
            text: 'My Orders',
            to: {
              name: 'MyOrders',
            },
            style: {
              fontSize: '12px',
              color: this.$route.name === 'MyOrders' ? 'var(--v-primary300-base)' : '',
              fontWeight: this.$route.name === 'MyOrders' ? 'bold' : 'normal',
            },
          },
        ];
      } else if (this.$store.getters.roles === 'institution-representative') {
        const activeMarketplace =
          this.$route.path.includes('/marketplace/services') ||
          this.$route.path.includes('/marketplace/equipment') ||
          this.$route.path.includes('/marketplace/providers') ||
          this.$route.path.includes('/marketplace/patents') ||
          this.$route.path.includes('/marketplace/hosting-institutions');
        return [
          {
            icon: 'dashboard',
            text: 'Dashboard',
            to: {
              name: 'Dashboard',
            },
            style: {
              fontSize: '12px',
              color: this.$route.name === 'Dashboard' ? 'var(--v-primary300-base)' : '',
              fontWeight: this.$route.name === 'Dashboard' ? 'bold' : 'normal',
            },
            disabled: this.isFirstTime(),
          },
          {
            icon: 'marketplace',
            text: 'Catalogue',
            to: {
              path: '/marketplace/services',
              query: {
                selectedCatalogue: 'Browse the Catalogue of Services',
              },
            },
            style: {
              fontSize: '12px',
              color: activeMarketplace ? 'var(--v-primary300-base)' : '',
              fontWeight: activeMarketplace ? 'bold' : 'normal',
            },
          },
          {
            icon: 'favorite',
            text: 'Favorites',
            to: {
              name: 'MyFavorites',
            },
            style: {
              fontSize: '12px',
              color: this.$route.name === 'MyFavorites' ? 'var(--v-primary300-base)' : '',
              fontWeight: this.$route.name === 'MyFavorites' ? 'bold' : 'normal',
            },
            disabled: this.isFirstTime(),
          },
          {
            icon: 'resources',
            text: 'My Resources',
            to: {
              name: 'HostingRepresentativeMyResources',
            },
            style: {
              fontSize: '12px',
              color:
                this.$route.name === 'HostingRepresentativeMyResources'
                  ? 'var(--v-primary300-base)'
                  : '',
              fontWeight:
                this.$route.name === 'HostingRepresentativeMyResources' ? 'bold' : 'normal',
            },
            disabled: this.isFirstTime(),
          },
          {
            icon: 'suggested',
            text: 'Suggested',
            to: {
              name: 'Suggested',
            },
            style: {
              fontSize: '12px',
              color: this.$route.name === 'Suggested' ? 'var(--v-primary300-base)' : '',
              fontWeight: this.$route.name === 'Suggested' ? 'bold' : 'normal',
            },
            disabled: this.isFirstTime(),
          },
          {
            icon: 'myCollection',
            text: 'My Orders',
            to: {
              name: 'MyOrders',
            },
            style: {
              fontSize: '12px',
              color: this.$route.name === 'MyOrders' ? 'var(--v-primary300-base)' : '',
              fontWeight: this.$route.name === 'MyOrders' ? 'bold' : 'normal',
            },
            disabled: this.isFirstTime(),
          },
          {
            icon: 'users',
            text: 'Members',
            to: {
              name: 'Members',
            },
            style: {
              fontSize: '12px',
              color: this.$route.name === 'Members' ? 'var(--v-primary300-base)' : '',
              fontWeight: this.$route.name === 'Members' ? 'bold' : 'normal',
            },
            disabled: this.isFirstTime(),
          },
        ];
      } else {
        return [];
      }
    },
    rightItems() {
      if (this.$store.getters.roles === 'super-admin') {
        const activeMarketplace =
          this.$route.path.includes('/marketplace/services') ||
          this.$route.path.includes('/marketplace/equipment') ||
          this.$route.path.includes('/marketplace/providers') ||
          this.$route.path.includes('/marketplace/patents') ||
          this.$route.path.includes('/marketplace/hosting-institutions');
        return [
          {
            icon: 'myCollection',
            text: 'Orders',
            to: {
              name: 'Orders',
            },
            style: {
              fontSize: '12px',
              color: this.$route.name === 'Orders' ? 'var(--v-primary300-base)' : '',
              fontWeight: this.$route.name === 'Orders' ? 'bold' : 'normal',
            },
          },
          {
            icon: 'marketplace',
            text: 'Catalogue',
            to: {
              path: '/marketplace/services',
              query: {
                selectedCatalogue: 'Browse the Catalogue of Services',
              },
            },
            style: {
              fontSize: '12px',
              color: activeMarketplace ? 'var(--v-primary300-base)' : '',
              fontWeight: activeMarketplace ? 'bold' : 'normal',
            },
          },
        ];
      } else if (this.$store.getters.roles === 'provider') {
        return [
          {
            icon: 'myCollection',
            text: 'Orders',
            to: {
              name: 'MyOrders',
            },
            style: {
              fontSize: '12px',
              color: this.$route.name === 'MyOrders' ? 'var(--v-primary300-base)' : '',
              fontWeight: this.$route.name === 'MyOrders' ? 'bold' : 'normal',
            },
            disabled: this.isFirstTime(),
          },
          {
            icon: 'users',
            text: 'Members',
            to: {
              name: 'Members',
            },
            style: {
              fontSize: '12px',
              color: this.$route.name === 'Members' ? 'var(--v-primary300-base)' : '',
              fontWeight: this.$route.name === 'Members' ? 'bold' : 'normal',
            },
            disabled: this.isFirstTime(),
          },
        ];
      } else {
        return [];
      }
    },
    campaignAndNewsItems() {
      if (this.$store.getters.roles === 'super-admin') {
        return [
          {
            icon: 'campaign',
            text: 'Campaign',
            to: {
              name: 'Campaign',
            },
            style: { fontSize: '12px' },
          },
          // {
          //   icon: 'newsAndEvents',
          //   text: 'News & Events',
          //   to: {
          //     name: 'NewsAndEvents',
          //   },
          //   style: { fontSize: '12px' },
          // },
        ];
      } else {
        return [];
      }
    },
    isAuthorized() {
      const role = this.$store.getters.roles;
      return role === 'super-admin' || role === 'provider';
    },
  },

  watch: {
    '$route.to': {
      handler: function() {
        this.updateBreadcrumb();
      },
      deep: true,
      immediate: true,
    },
    providerId(value) {
      this.selectedProviderId = this.providers.find(x => x.id == value).id;
    },
    selectedProviderId(value, oldValue) {
      if (oldValue != null) {
        localStorage.setItem('providerId', value);
        sessionStorage.setItem('providerId', value);
        // window.location.reload();

        const selectedCatalogue = 'Browse the Catalogue of Services';
        this.$router.push({
          path: '/marketplace/services',
          query: { selectedCatalogue },
        });
      }
    },
  },
};
</script>

<style>
#menu .v-toolbar {
  background: rgba(255, 255, 255, 1) !important;
  border-bottom: 1px solid rgba(220, 218, 224, 1);
}

.hover-effect {
  color: black;
  transition: color 0.1s ease;
}

.hover-effect:hover {
  color: var(--v-primary300-base) !important;
  font-weight: bold;
}
.no-background-hover::before {
  background-color: transparent !important;
}

.search-bar-container {
  width: auto;
  max-width: 350px;
  display: flex;
  flex-direction: row;
}

@media (max-width: 1564px) and (min-width: 1440px) {
  .search-bar-container {
    max-width: 420px;
  }
}

@media (max-width: 478px) {
  .search-bar-container {
    max-width: 590px;
  }
}
.expandable-content {
  position: fixed;
  top: 60px;
  left: 0;
  right: 0;
  z-index: 1;
  background: #f5f5f5;
}

.custom-column {
  display: none;
}

.custom-row {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  text-align: right;
}

#menu .custom-list {
  background-color: #f5f5f5;
}

.v-list-item:before {
  background-color: #f5f5f5;
}

.v-list-item span:hover {
  color: var(--v-primary300-base) !important;
  font-weight: bold;
}

.custom-nav-icon,
.custom-logo,
.custom-fitler-drawer-button {
  display: none;
}

/* Grouping media queries by breakpoints */
@media (max-width: 1919px) {
  .custom-nav-icon {
    display: inline-flex;
  }
}

@media (min-width: 1440px) {
  .custom-column {
    display: inline-flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
  }
}

@media (min-width: 1920px) {
  .custom-search-bar-button,
  .custom-logo {
    display: inline-block;
  }

  .custom-logo {
    margin-top: 10px;
  }
}

.disabled-link {
  pointer-events: none;
  opacity: 0.5;
  cursor: not-allowed;
}

.overlay-content {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 2;
}
</style>
